import React from 'react';
import { Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

import { DailyLimitField } from '@epi-containers/ManageBenefitGroups/components/DailyLimitField';
import { IBenefits } from '@epi-models/containers/ManageBenefits';
import { ICreateBenefitGroupForm } from '@epi-models/pages/BenefitGroups';

import { BenefitSettingsTooltip } from '../BenefitSettingsTooltip/BenefitSettingsTooltip';
import { SectionWrapper } from '../SectionWrapper/SectionWrapper';

type MyChoiceBenefitProps = {
  benefitName: IBenefits;
  maxAmounts: number[];
};

const MyChoiceBenefit = ({ benefitName, maxAmounts }: MyChoiceBenefitProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<ICreateBenefitGroupForm>();

  const value = watch(`benefitSettings.${benefitName}`);

  if (!value) {
    return null;
  }

  return (
    <Box width="calc(50% - 12px)">
      <SectionWrapper
        benefitName={benefitName}
        subtitle={t('components.benefit_tile.my_choice_subtitle')}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Box width="220px">
            <DailyLimitField
              label={t(
                `components.manage_benefit_${benefitName}.detail_limit_label`
              )}
              readOnly={false}
              benefitType={benefitName}
              options={[]}
              name={`benefitSettings.${benefitName}.maxAmountPerPeriod`}
              fundsLoadingTypeName={`benefitSettings.${benefitName}.fundsLoadingType`}
              maxAmounts={maxAmounts}
            />
          </Box>
          <BenefitSettingsTooltip
            descriptionKey={`components.manage_benefit_${benefitName}.detail_daily_limit_statement`}
          />
        </Box>
      </SectionWrapper>
    </Box>
  );
};

export { MyChoiceBenefit };
